import React, { Component, PropTypes } from 'react';
import TetherComponent from 'react-tether';
import classNames from 'classnames';

import { SectionHeading } from '@chartbeat/light-side/lib/components';

import { CATEGORIES, MEDIUMS } from '../../utils/category-utils.js';
import styles from './category-filter.cssm';


class CategoryFilter extends Component {

    static propTypes = {
        currentCategory: PropTypes.oneOf(CATEGORIES),
        onSetCategory: PropTypes.func,
        onClearCategory: PropTypes.func,
        onSetPreview: PropTypes.func,
        onClearPreview: PropTypes.func,
        onHoverMedium: PropTypes.func,
        onClearHover: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {visibleTooltip : false};
    }

    categoryClickFn = (newCategory) => {
        if (this.props.onSetCategory) {
            return () => this.props.onSetCategory(newCategory);
        }
    }

    setPreviewFn = (previewCategory) => {
        if (this.props.onSetPreview) {
            return () => this.props.onSetPreview(previewCategory)
        }
    }

    getCategoryClass(category) {
        if (this.props.currentCategory
            && category.className === this.props.currentCategory.className) {
            return styles[`${category.className}ButtonActive`]
        } else {
            return styles[`${category.className}Button`]
        }
    }

    tooltipOn = (medium) => {
        this.props.onHoverMedium(medium);
        this.setState({
            visibleTooltip: medium.className
        });
    }
    tooltipOff = () => {
        this.props.onClearHover();
        this.setState({
            visibleTooltip: false
        });
    }

    renderTopicFilters = () => {
        return (
        <div>
            <div onClick={this.props.onClearCategory}
                className={(!this.props.currentCategory) ?
                styles.allButtonActive : styles.allButton}>
                <SectionHeading>All</SectionHeading>
            </div>
            {CATEGORIES.map((category) => {
                return (
                <div key={category.label} className={styles.buttonContainer}>
                    <div onClick={this.categoryClickFn(category)}
                         onMouseEnter={this.setPreviewFn(category)}
                         onMouseLeave={this.props.onClearPreview}
                         className={this.getCategoryClass(category)}>
                        <SectionHeading>
                            {category.label}
                        </SectionHeading>
                    </div>
                </div>
                );
            })}
        </div>
        );
    }

    getMediumClass(medium) {
        return styles[`${medium.className}Icon`];
    }
    renderMediumButton = (medium) => {
        const refName = `${medium}Button`;

        return (<div
            key={medium.label}
            ref={refName}
            className={styles.mediumButton}
            onMouseEnter={() => {this.tooltipOn(medium)}}
            onMouseLeave={this.tooltipOff}>
                <div className={this.getMediumClass(medium)} />
                <div className={styles.mediumLabel}>{medium.label}</div>
        </div>);
    }
    renderMediumTooltip = (medium) => {
        return (
        <div className={styles.tooltipText}>
            {medium.description}
        </div>
        );
    }

    renderMediumFilters() {
        let attachment = window.innerHeight < 900 ? 'bottom left' : 'top left';
        return <div>
            {MEDIUMS.map((medium) => {
                return (
                <TetherComponent
                    key={medium.label}
                    attachment={attachment}
                    classes={{element: styles.tooltip}}
                    constraints={[{
                        to: 'parent',
                       attachment: 'together',
                       pin: true}
                    ]}>
                        {this.renderMediumButton(medium)}
                        {this.state.visibleTooltip &&
                            this.state.visibleTooltip === medium.className &&
                            this.renderMediumTooltip(medium)
                        }
                </TetherComponent>
                );
            })}
        </div>;
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.topicsFilter}>
                    <div className={styles.label}>Filter by Topic</div>
                    {this.renderTopicFilters()}
                </div>
                <div className={classNames(styles.mediumFilter, styles.muted)}>
                    {this.renderMediumFilters()}
                </div>
            </div>
        );
    }
}

export default CategoryFilter;



// WEBPACK FOOTER //
// ./src/components/category-filter/category-filter.js